import api from './api';

export interface TipoDocumentoSeguroGarantia {
  id: string;
  nome: string;
  codigo?: number;
}

export const getAllTipoDocumentoSeguroGarantia = () => api.get<TipoDocumentoSeguroGarantia[]>('tipoDocumentoSeguroGarantia');

export const getTipoDocumentoSeguroGarantiaOptions = () => getAllTipoDocumentoSeguroGarantia()
.then(TipoDocumentoSeguroGarantia => (TipoDocumentoSeguroGarantia || []).map(item => ({text: item.nome, value: item.id.toString()})))

